import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppServices } from './../../app.services';
import { NotifyService } from './../../addon/notify.service';

import * as _ from 'lodash';
import * as moment from 'moment';
import * as vis from 'vis';

declare var $:any;
declare var VTree:any;

@Component({
	selector: 'app-myworks',
	templateUrl: './myworks.component.html',
	styleUrls: ['./myworks.component.css']
})
export class MyworksComponent implements OnInit {
	filter_proj = {}
	data_proj; proj
	filter_task = {}
	data_task
	list_member;
	constructor(private router: Router, private appServices: AppServices, private notifyService: NotifyService) { }

	ngOnInit() {
		if(this.appServices.session.length > 0) {
			this.loadProj();
			this.searchMember();
		} else {
			this.router.navigate(['main/home']);
		}
	}
	assign(frm, data) {
		$.each(data, function(key){
			frm[key] = data[key];
		})
	}

	searchMember(filter = {}) {
		Object.assign(filter, {"accountcode":{"inq":[this.appServices.accountcode]}, "deleted": false})
		this.appServices.api('Members/find', {
			'filter': `{"where":${JSON.stringify(filter)}, "skip": 0}`
		}, this).then(function(obj){
			let json = obj.response.json();
			obj.component.list_member = json.res;
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	loadProj(param = null, add = false) {
		let filter = this.filter_proj;
		if(param) {
			filter = $.extend(filter, param);
			let paramIndex = Object.keys(filter).indexOf(Object.keys(param)[0]);
			if(!(Object.values(filter)[paramIndex])){
				delete filter[Object.keys(param)[0]];
			}
		}
		Object.assign(filter, {'deleted':false, 'accountcode': this.appServices.accountcode, 'codeorg': this.appServices.appname})
		this.appServices.api('Projects/find', {
			'filter': `{"where":${JSON.stringify(filter)},"skip":${add ? this.data_proj.res.length : 0},"order":"created_dt desc"}`
		}, this).then(function(obj){
			let json = obj.response.json();
			if(add) {
				obj.component.data_proj.res = obj.component.data_proj.res.concat(json.res);
			} else {
				obj.component.data_proj = json;
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	loadTask(param = null, add = false) {
		let filter = this.filter_task;
		if(param) {
			filter = $.extend(filter, param);
			let paramIndex = Object.keys(filter).indexOf(Object.keys(param)[0]);
			if(!(Object.values(filter)[paramIndex])){
				delete filter[Object.keys(param)[0]];
			}
		}
		Object.assign(filter, {'deleted':false})
		this.appServices.api('Tasks/find', {
			'filter': `{"where":${JSON.stringify(filter)},"skip":${add ? this.data_task.res.length : 0},"order":"duedate"}`
		}, this).then(function(obj){
			let json = obj.response.json();
			if(add) {
				obj.component.data_task.res = obj.component.data_task.res.concat(json.res);
			} else {
				obj.component.data_task = json;
			}
			obj.component.loadTM();
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	loadTM() {
		this.appServices.api('Taskxmembers/count', {
			'filter': `{"deleted": false, "codeproject": "${this.proj.code}"}`
		}, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.appServices.api('Taskxmembers/find', {
				'filter': `{"where":{"deleted": false, "codeproject": "${obj.component.proj.code}"}, "limit":${res}}`
			}, obj.component).then(function(obj){
				let json = obj.response.json();
				let tree = json.res.reduce((a, b) => {
					let find = a.find(f => f.codemember == b.codemember)
					if(find) {
						Object.assign(find, {
							[b.code]: {
								'name': b.task.name,
								'detail': b.task.detail,
								'date': {
									'start': moment(b.task.startdate).fromNow(),
									'end': moment(b.task.duedate).fromNow()
								}
							}
						})
					} else {
						a.push({
							'codemember': b.member.code,
							'member': b.member.name,
							[b.task.code]: {
								'name': b.task.name,
								'detail': b.task.detail,
								'date': {
									'start': moment(b.task.startdate).fromNow(),
									'end': moment(b.task.duedate).fromNow()
								}
							}
						})
					}
					return a
				}, [])
				obj.component.treeProj(tree);
			}).catch(function(err){
				err.component.notifyService.show(err.err.json().error.message, 'danger');
			})
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	moreProj() {
		this.loadProj(this.filter_proj, true);
	}
	moreTask() {
		this.loadTask(this.filter_task, true);
	}
	saveProj(data) {
		data = _.pickBy(data)
		data['codeorg'] = this.appServices.appname;
		data['accountcode'] = this.appServices.accountcode;
		data['deleted'] = false;
		this.appServices.api('Projects/save', data, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.loadProj()
			obj.component.proj = data;
			obj.component.notifyService.show(obj.response.statusText);
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	saveTask(data) {
		data = _.pickBy(data);
		data['deleted'] = false;
		data['codeproject'] = this.proj.code;
		data['codemember'] = data.codemember ? data.codemember : this.appServices.session[0].member.code
		this.appServices.api('Tasks/save', data, this).then(function(obj){
			let res = obj.response.json().res;
			if(res.code) {
				data['codetask'] = res.code
			} else {
				data['codetask'] = data.code;
				delete data.code;
			}
			obj.component.appServices.api('Taskxmembers/save', data, obj.component).then(function(obj){
				let res = obj.response.json().res;
				obj.component.loadTask()
				obj.component.notifyService.show(obj.response.statusText);
			}).catch(function(err){
				err.component.notifyService.show(err.err.json().error.message, 'danger');
			})
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	doneTask(data) {
		this.appServices.api('Tasks/save', {
			'code': data.code,
			'deleted': true
		}, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.appServices.api('Taskxmembers/count', {
				'filter': `{"deleted": false, "codetask": "${data.code}"}`
			}, obj.component).then(function(obj){
				let res = obj.response.json().res;
				obj.component.appServices.api('Taskxmembers/find', {
					'filter': `{"where":{"deleted": false, "codetask": "${data.code}"}, "limit":${res}}`
				}, obj.component).then(function(obj){
					let res = obj.response.json().res;
					let pack = res.map(el => {
						return {'code':el.code,'deleted':true}
					})
					obj.component.appServices.api('Taskxmembers/savepack', {
						'data': pack
					}, obj.component).then(function(obj){
						let res = obj.response.json().res;
						obj.component.loadTask()
						obj.component.notifyService.show(obj.response.statusText);
					}).catch(function(err){
						err.component.notifyService.show(err.err.json().error.message, 'danger');
					})
				}).catch(function(err){
					err.component.notifyService.show(err.err.json().error.message, 'danger');
				})
			}).catch(function(err){
				err.component.notifyService.show(err.err.json().error.message, 'danger');
			})
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	treeProj(data) {
		$('#vtree').empty();
		setTimeout(() => {
			let vt = new VTree(document.getElementById('vtree'));
			let reader = new VTree.reader.Object();
			vt.data(reader.read(data)).update();
		}, 500)
	}
}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/main/myworks/myworks.component.ts